<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="pgepubid00000">
<h1><i>The</i><br/>
MOVING FINGER</h1>
</div>
<div class="chapter">
<div class="poetry-container">
<div class="poetry">
<div class="bbox">
<p class="ph1">By NATALIE SUMNER LINCOLN</p>
<hr class="tiny"/>
<table>
<tbody><tr><td>The Moving Finger</td>
<td>I Spy</td>
</tr>
<tr><td>The Nameless Man</td>
<td>C. O. D.</td>
</tr>
<tr><td>The Official Chaperon     </td>
<td>The Man Inside</td>
</tr>
<tr><td>The Lost Despatch</td>
<td>The Trevor Case</td>
</tr>
</tbody>
</table>
<hr class="full"/>
<p>D. APPLETON &amp; COMPANY, NEW YORK</p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3186253215635795556_74210-h-1.htm.vue?bf09baba